var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpiReceipts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2864 2.66699H18.8735V4.25413H17.2864V2.66699Z",
    fill: "url(#paint0_linear_1743_14326)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0471 2.66699H23.6347V4.25413H22.0471V2.66699Z",
    fill: "url(#paint1_linear_1743_14326)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00012 2.66699V13.7783H14.1114V2.66699H3.00012ZM12.5239 12.1908H4.58762V4.25449H12.5239V12.1908Z",
    fill: "url(#paint2_linear_1743_14326)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8733 4.25391H22.048V5.84104H23.6352V7.42889H20.4609V5.84104H18.8733V4.25391Z",
    fill: "url(#paint3_linear_1743_14326)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2223 2.66699V13.7783H36.333V2.66699H25.2223ZM34.7455 12.1908H26.8098V4.25449H34.7461V12.1908H34.7455Z",
    fill: "url(#paint4_linear_1743_14326)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17395 5.84082H10.9361V10.6029H6.17395V5.84082Z",
    fill: "url(#paint5_linear_1743_14326)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6995 5.84082H17.2866V7.42867H18.8737V9.01581H22.0485V10.6029H23.6356V15.3651H22.0485V16.9522H23.6356V18.5393H20.4614V20.127H18.8737V16.9522H20.4614V15.3651H18.8737V16.9522H17.2866V13.7777H18.8737V10.6029H17.2866V9.01581H15.6995V5.84082Z",
    fill: "url(#paint6_linear_1743_14326)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3961 5.84082H33.1582V10.6029H28.3961V5.84082Z",
    fill: "url(#paint7_linear_1743_14326)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6995 12.1904H17.2871V13.778H15.6995V12.1904Z",
    fill: "url(#paint8_linear_1743_14326)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76221 15.3652H10.9365V16.9524H12.5236V18.5395H14.1112V20.1271H12.5236V21.7143H14.1112V20.1271H15.6986V21.7143H17.2857V23.3014H20.4605V21.7143H22.0476V24.8888H20.4605V26.4764H15.6986V23.3014H7.76233V21.7143H9.34946V20.1271H10.9366V18.5395H9.34946V16.9524H7.76233L7.76221 15.3652Z",
    fill: "url(#paint9_linear_1743_14326)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5243 15.3652H15.6986V16.9528H12.5243V15.3652Z",
    fill: "url(#paint10_linear_1743_14326)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9846 15.3652H33.1596V16.9524H31.5725V20.1271H29.9846V18.5395H28.397V20.1271H29.9846V21.7143H33.1596V20.1271H34.7463V21.7143H36.3339V23.3014H34.7463V24.8888H33.1596V26.4764H36.3339V29.6507H34.7463V28.063H33.1596V29.6507H31.5725V26.4764H29.9846V24.8888H31.5725V23.3014H26.8104V24.8888H23.6354V20.1271H26.8104V18.5395H25.2232V16.9524H29.9846V15.3652Z",
    fill: "url(#paint11_linear_1743_14326)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00012 16.9521H6.1744V18.5393H9.34939V20.1269H6.1744V21.714H4.58726V18.5393H3.00012V16.9521Z",
    fill: "url(#paint12_linear_1743_14326)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6995 16.9521H17.2871V20.1264H15.6995V16.9521Z",
    fill: "url(#paint13_linear_1743_14326)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7465 16.9521H36.3341V20.1264H34.7465V16.9521Z",
    fill: "url(#paint14_linear_1743_14326)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00012 21.7148H4.58726V23.3025H3.00012V21.7148Z",
    fill: "url(#paint15_linear_1743_14326)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00012 24.8887V35.9999H14.1114V24.8887H3.00012ZM12.5239 34.4125H4.58762V26.4768H12.5239V34.4125Z",
    fill: "url(#paint16_linear_1743_14326)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0471 26.4766H23.6347V28.0637H22.0471V26.4766Z",
    fill: "url(#paint17_linear_1743_14326)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17395 28.0635H10.9361V32.8256H6.17395V28.0635Z",
    fill: "url(#paint18_linear_1743_14326)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6995 28.0635H17.2866V29.6511H18.8737V31.2382H20.4614V32.8261H22.0485V34.4127H18.8737V36.0004H17.2866V31.2382H15.6995V28.0635Z",
    fill: "url(#paint19_linear_1743_14326)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8733 28.0635H22.0476V29.6511H18.8733V28.0635Z",
    fill: "url(#paint20_linear_1743_14326)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2223 28.0635H26.8094V29.6511H28.3961V28.0635H29.9837V31.2382H31.5716V34.4127H29.9837V32.8261H28.3961V34.4127H29.9837V36.0004H26.8094V31.2382H25.2223V28.0635Z",
    fill: "url(#paint21_linear_1743_14326)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1595 31.2383H36.3338V34.4126H33.1595V31.2383Z",
    fill: "url(#paint22_linear_1743_14326)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.634 32.8262H25.2216V34.4133H23.634V32.8262Z",
    fill: "url(#paint23_linear_1743_14326)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0471 34.4131H23.6347V36.0007H22.0471V34.4131Z",
    fill: "url(#paint24_linear_1743_14326)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5726 34.4131H33.1598V36.0007H31.5726V34.4131Z",
    fill: "url(#paint25_linear_1743_14326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1743_14326",
    x1: 17.2864,
    y1: 3.46056,
    x2: 18.8735,
    y2: 3.46056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1743_14326",
    x1: 22.0471,
    y1: 3.46056,
    x2: 23.6347,
    y2: 3.46056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1743_14326",
    x1: 3.00012,
    y1: 8.22263,
    x2: 14.1114,
    y2: 8.22263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1743_14326",
    x1: 18.8733,
    y1: 5.8414,
    x2: 23.6352,
    y2: 5.8414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1743_14326",
    x1: 25.2223,
    y1: 8.22263,
    x2: 36.333,
    y2: 8.22263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1743_14326",
    x1: 6.17395,
    y1: 8.22188,
    x2: 10.9361,
    y2: 8.22188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1743_14326",
    x1: 15.6995,
    y1: 12.9839,
    x2: 23.6356,
    y2: 12.9839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1743_14326",
    x1: 28.3961,
    y1: 8.22188,
    x2: 33.1582,
    y2: 8.22188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1743_14326",
    x1: 15.6995,
    y1: 12.9842,
    x2: 17.2871,
    y2: 12.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1743_14326",
    x1: 7.76221,
    y1: 20.9208,
    x2: 22.0476,
    y2: 20.9208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1743_14326",
    x1: 12.5243,
    y1: 16.159,
    x2: 15.6986,
    y2: 16.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1743_14326",
    x1: 23.6354,
    y1: 22.5079,
    x2: 36.3339,
    y2: 22.5079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1743_14326",
    x1: 3.00012,
    y1: 19.3331,
    x2: 9.34939,
    y2: 19.3331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1743_14326",
    x1: 15.6995,
    y1: 18.5393,
    x2: 17.2871,
    y2: 18.5393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1743_14326",
    x1: 34.7465,
    y1: 18.5393,
    x2: 36.3341,
    y2: 18.5393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1743_14326",
    x1: 3.00012,
    y1: 22.5087,
    x2: 4.58726,
    y2: 22.5087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1743_14326",
    x1: 3.00012,
    y1: 30.4443,
    x2: 14.1114,
    y2: 30.4443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1743_14326",
    x1: 22.0471,
    y1: 27.2701,
    x2: 23.6347,
    y2: 27.2701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1743_14326",
    x1: 6.17395,
    y1: 30.4445,
    x2: 10.9361,
    y2: 30.4445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1743_14326",
    x1: 15.6995,
    y1: 32.0319,
    x2: 22.0485,
    y2: 32.0319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1743_14326",
    x1: 18.8733,
    y1: 28.8573,
    x2: 22.0476,
    y2: 28.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1743_14326",
    x1: 25.2223,
    y1: 32.0319,
    x2: 31.5716,
    y2: 32.0319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1743_14326",
    x1: 33.1595,
    y1: 32.8254,
    x2: 36.3338,
    y2: 32.8254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1743_14326",
    x1: 23.634,
    y1: 33.6197,
    x2: 25.2216,
    y2: 33.6197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1743_14326",
    x1: 22.0471,
    y1: 35.2069,
    x2: 23.6347,
    y2: 35.2069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1743_14326",
    x1: 31.5726,
    y1: 35.2069,
    x2: 33.1598,
    y2: 35.2069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiReceipts);
export default __webpack_public_path__ + "static/media/UPIReceipts.5baee6d0c867618c6c83232bc44832fc.svg";
export { ForwardRef as ReactComponent };